import { StylesContext } from "@material-ui/styles"
import styled from "styled-components"
import React from "react"

const Container = styled("div")`
width: 100vw;
height: 150 px;
background-color: cyan;
margin: 25px; 
justify-content: center;

padding: 10 px 0;
display: flex;
flex-direction: column;
align-items: center;
`

const ListItem = styled("li")`
    margin: 10px;  
`
 
const FAQ4 = () => {
    return (
        <Container>

        <h2>WHAT ARE THE GOALS OF THIS PROJECT?</h2>

        <ul style={{padding: '0px 25%'}}>

        We want to encourage the NFT community to be physically active along with making fat stacks on your computers! Live long, live happy, and live healthy fellow apes! This genesis collection will provide access to future related projects. Maybe a nice thick set of lats, or perhaps even a leg...?   

        </ul>
        </Container>

    )
}

export default FAQ4;